import React, { useState } from 'react';
import { 
    Container,
    Box,
    Typography,
    Button,
    Paper,
    CircularProgress,
    Alert
} from '@mui/material';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../../config/api';

function Profile() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const connectGoogleDrive = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await fetch(API_ENDPOINTS.auth.googleAuth(), {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Sunucu yanıt vermedi');
            }

            const data = await response.json();

            if (data.authUrl) {
                // Yeni pencerede açmak yerine doğrudan yönlendir
                window.location.href = data.authUrl;
            } else {
                throw new Error('Yetkilendirme URL\'i alınamadı');
            }
        } catch (error) {
            console.error('Google Drive bağlantı hatası:', error);
            setError(error.message || 'Google Drive bağlantısı sırasında bir hata oluştu');
            toast.error(error.message || 'Google Drive bağlantısı sırasında bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4, mb: 4 }}>
                <Paper sx={{ p: 4, borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Profil Ayarları
                    </Typography>
                    
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" gutterBottom>
                            Google Drive Bağlantısı
                        </Typography>
                        
                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={connectGoogleDrive}
                            disabled={loading}
                            startIcon={loading && <CircularProgress size={20} color="inherit" />}
                            sx={{
                                py: 1.5,
                                px: 3,
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#1565c0'
                                }
                            }}
                        >
                            {loading ? 'Bağlanıyor...' : 'Google Drive\'a Bağlan'}
                        </Button>
                        
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                            Google Drive bağlantısı, fotoğraflarınızı güvenli bir şekilde depolamanızı sağlar.
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
}

export default Profile;
